import { useQueries } from '@tanstack/react-query';
import api from '../../http';
import { OCR_TIMEOUT_MS } from './ocr.constants';
import type { OcrFoliarSample, OcrSoilSample, OcrVerifyJobResponse } from './useGetOcrVerifyJob';

export const useGetOcrQueueVerify = (pendingItems: ReadonlyArray<{ jobId?: string }>) => {
	return useQueries({
		queries: pendingItems.map((item) => ({
			queryKey: ['ocrQueueVerify', item.jobId],
			queryFn: async ({ signal }) => {
				const { data } = await api.get<OcrVerifyJobResponse<OcrSoilSample | OcrFoliarSample>>(
					`/ocr/verifyJob/${item.jobId}`,
					{ timeout: OCR_TIMEOUT_MS, signal }
				);
				return data;
			},
			refetchInterval: 3000,
		})),
	});
};
